import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Headline5 from './Typography/Heading/Headline5';
import Body1 from './Typography/Body/Body1';
import InnerHtmlStyling from './InnerHtmlStyling';
import { Grid, GridCell } from './Grid';

const Container = styled(GridCell)`
  && {
    margin: 0 auto;
  }
`;

const StyledDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

  .mdc-icon-button {
    outline: none;
    cursor: pointer;

    div {
      height: 50px;
      width: 50px;
    }

    .material-icons {
      height: 50px;
      width: 50px;
    }
  }
`;

const AdditionalInformation = styled(InnerHtmlStyling)`
  /* stylelint-disable-next-line selector-type-no-unknown */
  && progressive-img {
    width: 128px;
    height: 40px;
    margin: auto;
    padding: 0;
  }
`;

const Description = styled(InnerHtmlStyling)`
  /* stylelint-disable-next-line selector-type-no-unknown */
  && progressive-img {
    width: 250px;
    margin: auto;
    padding-top: 20px;
  }

  .image-container:first-of-type {
    height: 260px;
  }

  /* stylelint-disable-next-line selector-type-no-unknown */
  .image-container:first-of-type progressive-img {
    padding-top: 0;
    height: 260px;
    --img-height: 260px;
  }
`;

const StyledHeader = styled(Headline5)`
  && {
    margin-block-start: 0;
    margin-block-end: 0;
  }
`;

const Text = styled(Body1)`
  && {
    color: rgb(0, 0, 0);
  }
`;

const Content = styled(Grid)`
  && {
    max-width: 740px;
  }
`;

const Course = ({
  breadcrumbs, title, companyName, location, education,
  description, additionalInformation, shareButtons,
}) => (
  <Container padding="0">
    <Content>
      <GridCell xs={12} padding="0 20px 20px">
        {breadcrumbs}
      </GridCell>
      <GridCell xs={7} padding="20px">
        <StyledHeader tag="h1">
          {title}
        </StyledHeader>
      </GridCell>
      <GridCell xs={5} padding="20px">
        <StyledHeader tag="h2">
          Course Summary School:
          <Text tag="span">
            {' '}
            {companyName}
          </Text>
        </StyledHeader>
        <StyledHeader tag="h2">
          Location:
          <Text tag="span">
            {' '}
            {location}
          </Text>
        </StyledHeader>
        <StyledHeader tag="h2">
          Education:
          <Text tag="span">
            {' '}
            {education}
          </Text>
        </StyledHeader>
      </GridCell>
      <GridCell padding="0 20px 20px">
        <Description
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <AdditionalInformation
          dangerouslySetInnerHTML={{ __html: additionalInformation }}
        />
        <StyledDiv>
          {shareButtons}
        </StyledDiv>
      </GridCell>
    </Content>
  </Container>
);

Course.propTypes = {
  breadcrumbs: PropTypes.node,
  title: PropTypes.string,
  companyName: PropTypes.string,
  location: PropTypes.string,
  education: PropTypes.string,
  description: PropTypes.string,
  additionalInformation: PropTypes.string,
  shareButtons: PropTypes.node,
};
Course.defaultProps = {
  breadcrumbs: undefined,
  title: undefined,
  companyName: undefined,
  location: undefined,
  education: undefined,
  description: undefined,
  additionalInformation: undefined,
  shareButtons: undefined,
};

export default Course;
